var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeleteTag(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "trash"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M3 4.9974H4.66667M4.66667 4.9974H18M4.66667 4.9974V16.6641C4.66667 17.1061 4.84226 17.53 5.15482 17.8426C5.46738 18.1551 5.89131 18.3307 6.33333 18.3307H14.6667C15.1087 18.3307 15.5326 18.1551 15.8452 17.8426C16.1577 17.53 16.3333 17.1061 16.3333 16.6641V4.9974H4.66667ZM7.16667 4.9974V3.33073C7.16667 2.8887 7.34226 2.46478 7.65482 2.15222C7.96738 1.83966 8.39131 1.66406 8.83333 1.66406H12.1667C12.6087 1.66406 13.0326 1.83966 13.3452 2.15222C13.6577 2.46478 13.8333 2.8887 13.8333 3.33073V4.9974",
    stroke: "#F04438",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteTag);
export default __webpack_public_path__ + "static/media/deleteTag.a3da1655dd57dc73b642e4af10e8169a.svg";
export { ForwardRef as ReactComponent };